module.exports = __webpack_public_path__ + "Sailec-Bold.efcf222a51c5bb9f8703.otf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Bold/Sailec-Bold.otf
// module id = ../../../../../src/assets/fonts/Sailec-Bold/Sailec-Bold.otf
// module chunks = styles